import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { DIAGNOSTICS_ROLE } from '@core/models/diagnostics';
import { AuthService } from '@core/services/auth';
import { DIAGNOSTICS_API_URL } from '@core/services/diagnostics';

/**
 * Matches the diagnostics route only where this environment publishes the API, and only for a token carrying the
 * diagnostics role; anyone else lands on the dashboard. A signed-out visitor matches, so the auth guard can send them
 * to sign in and bring them back to the link.
 */
export const diagnosticsGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const dashboard = router.createUrlTree(['/dashboard']);

  if (inject(DIAGNOSTICS_API_URL) === null) {
    return dashboard;
  }
  await auth.awaitReady();
  if (!auth.isAuthenticated()) {
    return true;
  }
  return auth.roles().includes(DIAGNOSTICS_ROLE) ? true : dashboard;
};
